






































import {
  Cirus
} from "@/classes/Http";
import {
  Component,
  Vue
} from "vue-property-decorator";
import LoginBgSvg from "./LoginBgSvg.vue";

@Component({
  components: {
    LoginBgSvg
  }
})
export default class LoginForm extends Vue {
  username = '';
  password = '';
  level = 0;
  loading = false;
  counter = 60;
  interval: any = null;
  next = '/shops';

  Errors: any = {
    400: "نام کاربری یا رمز عبور صحیح نمی‌باشد.",
    401: "رمز عبور را اشتباه وارد کرده اید.",
    402: "ورود به این بخش تنها برای کاربران پریمیوم امکان پذیر است.",
    403: "شما دسترسی لازم را ندارید",
    405: "ابتدا باید شماره همراه خود را تایید کنید.",
    404: "اطلاعات پیدا نشد.",
    412: "لطفا ابتدا شماره یا ایمیل خود را تایید کنید.",
    409: "اطلاعات وارد شده تکراری می‌باشد.",
    500: "مشکلی در سمت سرور رخ داده است. لطفا دوباره تلاش کنید.",
    unknown: 'لطفا دوباره تلاش کنید.'
  }

  public get Username(): string {
    return this.username.trim().replace(/[^\w]+/g, '');
  }


  public set Username(v: string) {
    v = v.trim();
    v = v.replace(/۰/g, '0');
    v = v.replace(/۱/g, '1');
    v = v.replace(/۲/g, '2');
    v = v.replace(/۳/g, '3');
    v = v.replace(/۴/g, '4');
    v = v.replace(/۵/g, '5');
    v = v.replace(/۶/g, '6');
    v = v.replace(/۷/g, '7');
    v = v.replace(/۸/g, '8');
    v = v.replace(/۹/g, '9');
    // v = v.replace(/\D/g,'');
    this.username = v.replace(/[^\w]+/g, '');
  }



  async login() {
    if (this.username.length === 1) {
      this.$message({
        showClose: true,
        message: "لطفا شماره تماس را صحیح وارد کنید.",
        type: "error",
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (this.password.length < 6) {
      this.$message({
        showClose: true,
        message: "رمز عبور حداقل ۶ حرف می‌باشد.",
        type: "error",
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    try {
      let res = await Cirus.login(this.Username, this.password);
      this.$store.commit('setUserToken', res.data.access_token)
      this.$store.commit("setRoles", res.data);
      this.$store.dispatch('auth');
      setTimeout(() => {
        if (this.next && this.next.charAt(0) === '/') this.$router.replace(this.next)
        else window.location.href = this.next;
      }, 1000);
    } catch (err) {
      this.$message.error(this.Errors[err.response.status]??this.Errors.unknown)
      if (err.response.status == 405) {
        setTimeout(() => {
          this.$router.push({
            name: 'forgot-password-user'
          })
        }, 500);
      } else if (err.response.status == 412) {
        setTimeout(() => {
          this.$router.push({
            name: 'forgot-password-user',
            query: {next: '/reset-password'}
          })
        }, 500);
      }
      // this.$message({
      //   showClose: true,
      //   message: "لطفا شماره تماس را صحیح وارد کنید.",
      //   type: "error",
      //   duration: 5000,
      // });
    } finally {
      this.loading = false;
    }
  }

  handleFormSubmit(event: Event) {
    if (event) event.preventDefault()
    this.loading = true;
    this.login();
  }

  mounted() {
    const query = this.$route.query;
    // this.$router.replace({query: {}})
    this.Username = query.username as string || "";
    if (typeof query.next == 'string' && query.next.length > 0) this.next = query.next;
  }
}
